import { PlatformSiteAri } from '@atlassian/ari/platform/site';

export type RovoMostUsedSite = {
  readonly siteId: string;
  readonly siteAri: string;
  readonly viewCount: number;
};

function toSiteId(siteAri: string): string | null {
  try {
    return PlatformSiteAri.parse(siteAri).siteId;
  } catch {
    return null;
  }
}

export function rankMostUsedSites(
  rootContainerIds: readonly (string | null | undefined)[],
): RovoMostUsedSite[] {
  const sitesBySiteAri = new Map<
    string,
    { siteId: string; viewCount: number }
  >();

  for (const siteAri of rootContainerIds) {
    if (!siteAri) {
      continue;
    }

    const siteId = toSiteId(siteAri);
    if (siteId == null) {
      continue;
    }

    const existingSite = sitesBySiteAri.get(siteAri);
    sitesBySiteAri.set(siteAri, {
      siteId,
      viewCount: (existingSite?.viewCount ?? 0) + 1,
    });
  }

  return Array.from(sitesBySiteAri.entries())
    .map(([siteAri, site]) => ({
      siteId: site.siteId,
      siteAri,
      viewCount: site.viewCount,
    }))
    .sort((left, right) => {
      if (right.viewCount !== left.viewCount) {
        return right.viewCount - left.viewCount;
      }

      return left.siteId.localeCompare(right.siteId);
    });
}
